import { useEffect } from 'react';
import { useGlobal } from '../../hooks';
import { Config } from '../ConfigFetcher/useConfig';
import { PortfolioUser } from 'rwl-shared/dist/models/portfolio/PortfolioUser';
import { useTechnician } from '../../hooks/useTechnician';

export function initPendo(
    config: Config,
    accountId: string,
    user?: PortfolioUser
): void {
    if (!('pendo' in globalThis)) {
        console.warn('Pendo is not loaded');
        return;
    }

    console.log(
        `Initializing Pendo for account ${accountId} for user ${user?.id} (${user?.email})`
    );

    pendo.initialize({
        visitor: {
            id: user?.id ?? '_portfolio_user',
            email: user?.email ?? 'unknown',
            full_name: user?.name ?? 'portfolio user',
        },
        account: {
            id: user?.account?.id ?? accountId,
            name: config.account.name,
            development: process.env.NODE_ENV === 'development',
        },
    });
}

export const PendoInit = (): null => {
    const { config, accountId } = useGlobal();
    const { technician, isTechnicianReady } = useTechnician();

    // initialize pendo if we're ready and we know what the user is. Either
    // a logged in user or a public user.
    useEffect(() => {
        if (config && isTechnicianReady && accountId) {
            initPendo(config, accountId, technician);
        }
    }, [config, isTechnicianReady, accountId]);

    return null;
};
